import Body from './components/body';


function App() {
  return (
    <>
      <Body/>
    </>
  );
}

export default App;